export const environment = {
  production: true,
  buildId: '3892224492123821',
  configFile: 'config.json',
};
